/**
 * Coerce a backend "boolean" flag to a real boolean.
 *
 * The API persists subsite toggles (s_fulladdress, s_state_license_show, …) as
 * 1/0 but they often come back as the STRINGS "1"/"0". Plain truthiness then
 * treats "0" as true, so toggles appear stuck "on". Use this everywhere a flag
 * is read.
 */
export default function isFlagOn(value) {
  if (value === true) return true
  if (value === false || value === null || value === undefined) return false

  const v = `${value}`.trim().toLowerCase()
  if (v === '' || v === '0' || v === 'false' || v === 'no' || v === 'off') return false

  return true
}
